var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',_vm._b({staticClass:"alert",class:{top: _vm.position === 'top', bottom: _vm.position === 'bottom'}},'div',_vm.$attrs,false),[_vm._t("alert-text")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }